import styled from 'styled-components'
import { PageColumn } from '@components/Page'
import { shellGutter } from '@/theme/layout'
import { media } from '@/theme/tokens'

// The page surface, header, and footer live in the shared @components/PublicPage
// shell (PublicShell); loading/unavailable states in the shared state pair.

/** The public overview's page column; on phones the gutters and floor respect a notch or home indicator. */
export const Container = styled(PageColumn)`
	${media.phone} {
		padding-right: max(${shellGutter.narrow}, env(safe-area-inset-right));
		padding-bottom: max(40px, env(safe-area-inset-bottom));
		padding-left: max(${shellGutter.narrow}, env(safe-area-inset-left));
	}
`
